<!--
 * @Descripttion:
 * @Author: voanit
 * @Date: 2022-03-30 14:00:43
 * @LastEditors: voanit
 * @LastEditTime: 2023-02-10 13:37:58
-->
<template>
  <div class="header">
    <img src="../../../../static/bannernew.png" alt="">
    <!-- <div class="logo">
     <div>
      <img src="../../../../static/logo2.png" alt="">
      <img src="../../../../static/logo1.png" alt="">

     </div>
      <div>
        <img src="../../../../static/logo4.png" alt="">
        <img src="../../../../static/logo3.png" alt="">
      </div>
    </div> -->
    <!-- <div class="header_sponsor_search">
					<div class="search_leftser">
						<el-select v-model="value" size="small" placeholder="" @change="searchselect">
							<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<i class="search_line"></i>
					<el-input size="small" v-model="searchval" @keyup.enter.native="search"></el-input>
					<div class="searcg_icon" @click="search">
						<img src="../../../../static/search.png" alt="">
					</div>
				</div> -->


         <!-- 悬停侧边栏 -->
    <div class="cebian" v-if="false">
      <ul>
        <!-- <li class="cebian_li" :style="{'background':item.colorA}"   v-for="(item,index) in cebian" :key="index" @mouseover="xuan(1,index)" @mouseout="xuan(2,index)"  @click="zhitop(index)"> -->
        <li
          class="cebian_li"
          v-for="(item, index) in cebian"
          :key="index"
          @mouseover="xuan(1, index)"
          @mouseout="xuan(2, index)"
          @click="zhitop(index)"
        >
          <!-- <div :class="item.name"></div> -->
          <img
            :src="item.img"
            style="float: left; margin: 15px -20px 0 10px"
            alt=""
            v-show="index !== 3"
          />
          <!-- <a v-show="index === 3" target="blank" :href="qqUrl"
            ><img border="0" :src="item.img" alt="点击这里给我发消息"
          /></a> -->
          <!-- <div style="fontSize:18px;marginTop:2px">{{item.name}}</div> -->
        </li>
      </ul>
    </div>
    <div
      class="cebian2"
      v-show="num == 4 || num == 5"
      :class="num == 4 ? 'top1' : 'top2'"
    >
      <div v-show="num == 4">联系我们</div>
    </div>

    <div
      class="pubMobLeft_right_cont"
      v-show="num == 2 || num == 1 || num == 3"
    >
      <div class="pubMobLeft_right_mid" v-show="num == 3">
        <img src="../../../../static/wzcode.png" />

        <div style="font-size: 18px; margin-top: 2px; margin-left: 60px">

        </div>
      </div>
      <div class="pubMobLeft_right_mid" v-show="num == 1">
        <img src="../../../../static/gzh.jpg" />
        <div style="font-size: 18px; margin-top: 2px; margin-left: 60px">
          <!-- 公众号 -->
        </div>
      </div>
      <div class="pubMobLeft_right_mid" v-show="num == 2">
        <img src="../../../../static/xcxcode.png" alt="" />
        <div style="font-size: 18px; margin-top: 2px; margin-left: 60px">
          <!-- 小程序 -->
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import router from '@/router/index'
import $ from 'jquery'
import Swiper from 'swiper'
import axios from 'axios'
import { mixin } from "../../../assets/script/scrollnav";
import { pagination } from '../../../../src/assets/mixin/data-table'

export default {
	name:'academicCircle',
  mixins: [pagination],
	data(){
		return{
       num: 0,
        gzh: "",
       xcx: "",
      cebian: [
        {
          img: "../../../../static/gzh.png",
          colorA: "#b80000",
          name: "公众号",
        },
        {
          img: "../../../../static/xcx.png",
          colorA: "#b80000",
          name: "小程序",
        },
        {
          img: "../../../../static/app.png",
          colorA: "#b80000",
          name: "App",
        },
        // {
        //   img: "../../../../static/qq.png",
        //   colorA: "#4a556e",
        //   name: "QQ",
        // },
      ],
			searchval:'',
			options: [
			{
				value: '资讯',
				label: '资讯',
				id:1
			}, {
				value: '期刊',
				label: '期刊',
				id:2
			}],
			value:'资讯',
			gettime:'',
			show:false,
			isShow:false,
			searchtype:'',
		}
  },
  methods:{
    //点击置顶页面
    zhitop(index) {
      if (index == 3) {
        document.documentElement.scrollTop = 0;
      }
    },
    //悬停侧边栏
    xuan(num, id) {
      if (num == 1) {
        this.num = id + 1;
        console.log('1231');
        for (var i = 0; i < this.cebian.length; i++) {
          if (id == i) {
            this.cebian[i].zt = true;
            this.cebian.push("1");
            this.cebian.pop("1");
          }
        }
      } else {
        this.num = 0;
        for (var i = 0; i < this.cebian.length; i++) {
          this.cebian[i].zt = false;
          this.cebian.push("1");
          this.cebian.pop("1");
        }
      }
    },
		searchselect(val){
			this.value = val
		},
    woon(url){
      window.open(url);
    },
    currentTime(){
      setInterval(this.getTime,500)
		},
		display(){
      this.show = !this.show
		},
		search(){
      this.isShow = !this.isShow
		},
		closeList(){
      this.show = !this.show
    },
		search() {
			if(this.value == ''){
				this.$message({
					message:'请选择标题',
					type:'error'
				})
			} else {
				this.$router.push({
					path:'/search',
					query:{
						whereName:this.searchval,
						keytype:this.value
					}
				})
			}
    },
  },
  components:{

  },
  created(){
    this.currentTime();
  },
  computed:{
    getTime(){
      var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth()+1;
      let dd = new Date().getDate();
      let ww = new Date().getDay();
      let wa = ['星期日','星期一','星期二','星期三','星期四','星期五','星期六']
      let hh = new Date().getHours();
      let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
      this.gettime = yy+'年'+mm+'月'+dd+ '日 ' + wa[ww];
    },
  }
}
</script>

<style scoped lang="less">
.header{
  min-width: 1200px;
  position: relative;
  background: url('../../../../static/bannernew.png')no-repeat 100% 100%;
  background-size: 100% 100%;
    >img{
  width: 100%;
  min-width: 1200px;
}
  .logo{
    position: absolute;
    top:53%;
    left:53%;
    transform: translate(-50%,-50%);
    img{
      margin-bottom:10px;
      margin-left:10px;
      width:80px;
      vertical-align: middle;
    }
  }
}



	.header_sponsor_search{
    position: absolute;
    bottom:50px;
    left:61%;
		width: 388px;
				height: 36px;
				border-radius: 18px;
				overflow: hidden;
				position: relative;
        background-color: #fff;
				.search_leftser{
					width: 79px;
					height: 34px;
					position: relative;
					.el-select{
						position: absolute;
						top: 0;
						/deep/.el-input__inner{
							height: 34px;
							border: none;
							outline: none;
							text-align: center;
						}
					}
				}
				.search_line{
					width: 1px;
					height: 14px;
					background: #A3A3A3;
					display: inline-block;
					position: absolute;
					top: 10px;
					left: 20%;
				}
				.el-input{
					width: 65%;
					position: absolute;
					left:84px;
					top: 0;
					/deep/.el-input__inner{
						border: none;
						outline: none;
					}
				}
				.searcg_icon{
					width: 51px;
					height: 36px;
					background: rgb(186,123,18);
					position: absolute;
					top: 0;
					right: 0;
					cursor: pointer;
					img{
						display: inline-block;
						width: 20px;
						position: relative;
						top: 6px;
						left: 13px;
					}
				}
			}



      .cebian {
  width: 55px;
  overflow: hidden;
  position: fixed;
  right: 20px;
  top: 38%;
  z-index: 100000000;
  ul {
    list-style: none;
    width: 100%;
    overflow: hidden;
    li {
      cursor: pointer;
      margin-bottom: 11px;
      float: left;
      width: 100%;
      height: 56px;
      background: #b80000;
      opacity: 0.8;
      text-align: center;

      div {
        margin: 0 auto;
        color: #ffffff;
        font-size: 25px;
        line-height: 56px;
      }
    }
  }
}
// .cebian_li:last-of-type {
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }
.cebian_li:hover {
  background: #6e5954;
}
.bianse {
  background-color: #e5332d !important;
  color: #ffffff !important;
}
.top1 {
  top: 57.5% !important;
}
.top2 {
  top: 65.5% !important;
}

.pubMobLeft_right_cont {
  width: 165px;
  // height: 255px;
  position: fixed;
  z-index: 100000000;
  right: 80px;
  top: 38%;

  .pubMobLeft_right_top {
    width: 100%;
    height: 54px;
    img {
      width: 100%;
      height: 100%;
      border-style: none;
      object-fit: cover;
    }
  }
  .pubMobLeft_right_mid {
    width: 100%;
    max-height: 200px;
    img {
      width: 100%;
      max-height: 100%;
      border: 1px solid #ccc;
    }
  }
  .pubMobLeft_right_bto {
    width: 100%;
    background: #b91e25;
    color: #fff;
    text-align: center;
    height: 38px;
    line-height: 38px;
    font-size: 14px;
    padding-top: 10px;
  }
  .pubMobLeft_right_close {
    font-size: 15px;
    color: #000;
    cursor: pointer;
    padding-top: 5px;
    background: #ffffff;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/HeaderBanner/index.vue